import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableTextInput extends React.Component {
    state = {

    }
componentDidMount(){

    if(this.props.header.key == 'tempAddress'){
        if(this.props.data){

            this.setState({inrental: true})
        }
    }
}

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        return (
            <div className={"w-100 h-100 flexcc "+this.props.header.information.alignCenter? "text-center":"text-start"}>
                <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.state.inrental ? 'In Rental':this.props.data!=null ? String(this.props.data):' '}</p>
                {/* <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data!=null ? String(this.props.data):' '}</p> */}
            </div>
        )
    }
}

export default TableTextInput;